module.exports = __webpack_public_path__ + "images/vero.e5b7fe9a70b19ea0683fb2c1f13136b8.png";